import React, { useCallback, useEffect, useState } from "react";
import { ErrorMessage, Formik, Form } from "formik";
import Div from "@jumbo/shared/Div";
import {
  Autocomplete,
  Button,
  DialogActions,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import jwtAuthAxios from "app/services/auth/jwtAuth";
import moment from "moment";
import * as Yup from "yup";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";

const CustomToolbar = () => {
  return (
    <GridToolbarContainer>
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
};

const BankBalance = () => {
  const swal = useSwalWrapper();
  const [HelperData, setHelperData] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState(false);
  const [currSymbol, setCurrSymbol] = useState();
  const [formval, setFormval] = useState({
    ACH_CODE: "",
    ACODE: "",
    p_frdt: "",
    p_todt: "",
    P_curr: "",
  });
  const { authUser } = useJumboAuth();

  const columns = [
    {
      field: "R_TRNDT",
      headerName: "Date",
      width: 185,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "ANAME", headerName: "Aname", width: 185 },
    { field: "OTH_NAME", headerName: "Oth Name", width: 185 },
    { field: "REMARK", headerName: "Remark", width: 350 },
    { field: "TYPE", headerName: "Type", width: 185 },
    {
      field: "DR_AMT",
      headerName: `Debit Amt(${currSymbol})`,
      width: 185,
      renderCell: ({ value }) => value?.toFixed(2),
    },
    {
      field: "CR_AMT",
      headerName: `Credit Amt(${currSymbol})`,
      width: 185,
      renderCell: ({ value }) => value?.toFixed(2),
    },
  ];

  const validationSchema = Yup.object().shape({
    p_frdt: Yup.string().required("First Date is required"),
    p_todt: Yup.string().required("To Date is required"),
    P_curr: Yup.string().required("Currency is required"),
  });

  const fetchGeneralLedgerData = useCallback(() => {
    jwtAuthAxios
      .get("acc/leagerMaster?bank=1")
      .then((res) => {
        setHelperData(res.data);
      })
      .catch(alert);
  }, []);

  const fetchGeneralLedgerCurrencyData = useCallback(() => {
    jwtAuthAxios
      .get("master/helper?curr=1")
      .then((res) => {
        setCurrency(res.data.data);
      })
      .catch(alert);
  }, []);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchGeneralLedgerData();
      fetchGeneralLedgerCurrencyData();
    }
  }, [fetchGeneralLedgerData, fetchGeneralLedgerCurrencyData]);

  const handleSubmit = async (values, { setSubmitting }) => {
    let payload = {
      ...values,
      ACH_CODE: values.ACH_CODE == null ? null : values.ACH_CODE,
      ACODE: values.ACODE == null ? null : values.ACODE,
    };
    await jwtAuthAxios
      .post("/accreport/ledgerreport", payload)
      .then((res) => {
        if (res.data?.status == "success") {
          setRows(res.data?.data);
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
    setStatus(true);
    setSubmitting(false);
    setCurrSymbol(
      currency?.CURR?.find((i) => i.FL_CURRENCY_ID === values.P_curr)
        ?.FL_SYMBOLE
    );
  };

  const handlePdf = async (values) => {
    await jwtAuthAxios
      .post("/accreport/reportworker", {
        P_CCOD: authUser?.branches[0]?.FL_COMPANY_CODE,
        p_acode: values.ACODE == null ? null : values.ACODE,
        p_frdt: moment(values.p_frdt).format("DD/MM/YYYY"),
        p_todt: moment(values.p_todt).format("DD/MM/YYYY"),
        p_curr: values.P_curr,
        p_ach_code: values.ACH_CODE == null ? null : values.ACH_CODE,
        P_BANK_LDGR_FLG: "Y",
        desformat: "PDF",
        report: "ACC_LEDGER.rdf",
        outfile: "ACC_LEDGER.pdf",
      })
      .then((res) => {
        if (res?.status == 200) {
          window.open(`https://admin.blossomdiam.com${res.data}`);
        } else {
          swal.fire({
            icon: "error",
            text: res.data.message,
          });
        }
      })
      .catch((e) => {
        swal.fire({
          icon: "error",
          text: "something Went Wrong",
        });
      });
  };
  return (
    <div>
      <div  style={{ padding: '20px' }}>
      <JumboCardQuick   title={'Bank Balance'} >
        <Paper elevation={0} >
        <Formik
          initialValues={formval}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            await handleSubmit(values, { setSubmitting });
          }}
        >
          {({
            values,
            handleChange,
            setValues,

            isSubmitting,
          }) => (
            <Form>
              <Grid container spacing={3}>
                <Grid item md={4} xs={12}>
                  <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                    <Select
                      size="small"
                      id="ACH_CODE"
                      value={values.ACH_CODE || []}
                      onChange={handleChange}
                      name="ACH_CODE"
                      displayEmpty
                      renderValue={
                        values.ACH_CODE != ""
                          ? undefined
                          : () => <InputLabel>Ach Name</InputLabel>
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Ach Code
                      </MenuItem>
                      {HelperData?.head?.map((item) => (
                        <MenuItem key={item.ACH_CODE} value={item.ACH_CODE}>
                          {item.ACH_NAME}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>
                  <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                    <Autocomplete
                      size="small"
                      id="ACODE"
                      options={values?.ACH_CODE ===""? HelperData?.ledger || []:
                        HelperData?.ledger?.filter(
                          (item) => item.ACH_CODE === values?.ACH_CODE
                        ) || []
                      }
                      disableCloseOnSelect
                      onChange={(event, newValue) => {
                        setValues({
                          ...values,
                          ACODE: newValue?.ACODE,
                        });
                      }}
                      getOptionLabel={(option) => option.ANAME || ""}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>{option.ANAME || ""}</li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Acode "
                          placeholder="..."
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.ACODE === value.ACODE
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>
                  <FormControl fullWidth margin="normal" sx={{ mt: 0 }}>
                    <Select
                      size="small"
                      id="P_curr"
                      value={values.P_curr || []}
                      onChange={handleChange}
                      name="P_curr"
                      displayEmpty
                      renderValue={
                        values.P_curr != ""
                          ? undefined
                          : () => <InputLabel>Currency</InputLabel>
                      }
                    >
                      <MenuItem value="" disabled>
                        Select Currency
                      </MenuItem>
                      {currency?.CURR?.map((item) => (
                        <MenuItem
                          key={item.FL_CURRENCY_ID}
                          value={item.FL_CURRENCY_ID}
                        >
                          {item.FL_CURRENCY_NAME}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <ErrorMessage
                    name="P_curr"
                    component="div"
                    style={{ color: "red", fontSize: "14px", marginTop: "4px" }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    margin="normal"
                    type="date"
                    label="First Date"
                    name="p_frdt"
                    value={values.p_frdt}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="p_frdt"
                    component="div"
                    style={{ color: "red", fontSize: "14px", marginTop: "4px" }}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    margin="normal"
                    type="date"
                    label="To Date"
                    InputLabelProps={{ shrink: true }}
                    name="p_todt"
                    value={values.p_todt}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="p_todt"
                    component="div"
                    style={{ color: "red", fontSize: "14px", marginTop: "4px" }}
                  />
                </Grid>
              </Grid>

              <DialogActions>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  disabled={isSubmitting}
                >
                  Search
                </Button>
                {status && (
                  <Div>
                    <PopupState variant="popover" popupId="demo-popup-menu">
                      {(popupState) => (
                        <React.Fragment>
                          <Button
                            variant="contained"
                            {...bindTrigger(popupState)}
                          >
                            Exports
                          </Button>
                          <Menu {...bindMenu(popupState)}>
                            <MenuItem onClick={() => handlePdf(values)}>
                              Pdf
                            </MenuItem>
                          </Menu>
                        </React.Fragment>
                      )}
                    </PopupState>
                  </Div>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
        </Paper>
        </JumboCardQuick>
        {status && (
          <div style={{ height: 300, width: "100%",marginTop: "30px" }}>
             <JumboCardQuick>
            <Paper elevation={0} >
              <DataGrid
                rows={rows}
                density="compact"
                getRowId={(e, i) => e.ID}
                columns={columns}
                slots={{
                  toolbar: CustomToolbar,
                }}
              />
            </Paper>
            </JumboCardQuick>
          </div>
        )}
      </div>
    </div>
  );
};

BankBalance.Modulename = "expensepayment";

export default BankBalance;
